import React from 'react';
import { Box, ButtonBase } from '@mui/material';
import { Backspace as BackspaceIcon } from '@mui/icons-material';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'C', '0', 'back'];
const MAX_DIGITS = 4;

// On-screen number pad. No <input>, so the phone keyboard never pops up.
export default function NumpadInput({ value, onChange, disabled = false }) {
  const handleKey = (key) => {
    if (key === 'back') { onChange(value.slice(0, -1)); return; }
    if (key === 'C') { onChange(''); return; }
    if (value.length >= MAX_DIGITS) return;
    onChange(value === '0' ? key : value + key);
  };

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
      {KEYS.map(key => (
        <ButtonBase
          key={key}
          disabled={disabled}
          aria-label={key === 'back' ? 'backspace' : key}
          onClick={() => handleKey(key)}
          sx={{
            height: 52,
            borderRadius: 2,
            fontSize: '1.4rem',
            fontWeight: 500,
            border: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
            color: key === 'C' ? 'text.secondary' : 'text.primary',
            '&:active': { bgcolor: 'action.selected' },
          }}
        >
          {key === 'back' ? <BackspaceIcon /> : key}
        </ButtonBase>
      ))}
    </Box>
  );
}
